import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE, PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawSummary(doc, summary, grandTotal,) {
  // doc.setFontSize(14);
  //doc.setFont("helvetica", "bold");
  // doc.text("CALCULATION SUMMARY ", 14, 20);
  //console.log ("Summery Data" , grandTotal);

const total=Number(grandTotal.proforma || 0)+Number(grandTotal.Labour || 0)+Number(grandTotal.freight ||0);
const total1=Number(grandTotal.DRR || 0)+Number(grandTotal.ReturnStore || 0)+Number(grandTotal.ElectricalJV ||0);


 autoTable(doc, {
  startY: doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 10
    : 120,

  ...PDF_TABLE_STYLE,

  theme: "grid",
  tableWidth: 180,

  // head: [
  //   ["", "Allocation Head", "OC/L (PU-34)", "Distribution", "OC/S (PU-35)"]
  // ],

  body: [
    ["LABOUR",  format(grandTotal.Labour)],
    ["FREIGHT",  format(grandTotal.freight)],
    ["PROFORMA ON COST",  format(grandTotal.proforma)],
    ["TOTAL",  format(total)],

      ],

  styles: {
    fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING1,
    textColor:PDFCOLORSHEME.BODY_TEXT_COLOR,
  },

  headStyles: {
    fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING1,
    textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING1,
    fontStyle: "bold",
    halign: "center",
  },

  columnStyles: {
    0: {
      halign: "center",
      cellWidth: 75,
    },
    1: {
      halign: "right",
      cellWidth: 115,
    },
   
  },
didParseCell: (data) => {
  if (
    data.section === "body" &&
    data.row.index === data.table.body.length - 1
  ) {
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.fontSize = 10;
    data.cell.styles.fillColor =
      PDFCOLORSHEME.BACK_COLOR_SUMMERY_TOTAL;
    data.cell.styles.textColor =
      PDFCOLORSHEME.FONT_COLOR_SUMMERY_TOTAL;
  }
},
 
});

  autoTable(doc, {
  startY: doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 10
    : 120,

  ...PDF_TABLE_STYLE,

  theme: "grid",
  tableWidth: 180,

  // head: [
  //   ["", "Allocation Head", "OC/L (PU-34)", "Distribution", "OC/S (PU-35)"]
  // ],

  body: [
    ["DRR",  format(grandTotal.DRR)],
    ["RETURN STORE",  format(grandTotal.ReturnStore)],
    ["ELEC. MANUFATURING",  format(grandTotal.ElectricalJV)],
    ["TOTAL",  format(total1)],

      ],

  styles: {
    fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING1,
    textColor:PDFCOLORSHEME.BODY_TEXT_COLOR,
  },

  headStyles: {
    fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING1,
    textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING1,
    fontStyle: "bold",
    halign: "center",
  },

  columnStyles: {
    0: {
      halign: "center",
      cellWidth: 75,
    },
    1: {
      halign: "right",
      cellWidth: 115,
    },
   
  },

 didParseCell: (data) => {
  if (
    data.section === "body" &&
    data.row.index === data.table.body.length - 1
  ) {
    data.cell.styles.fontStyle = "bold";
    data.cell.styles.fontSize = 10;
    data.cell.styles.fillColor =
      PDFCOLORSHEME.BACK_COLOR_SUMMERY_TOTAL;
    data.cell.styles.textColor =
      PDFCOLORSHEME.FONT_COLOR_SUMMERY_TOTAL;
  }
},
});
 
}

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}